export const COLUMN_ESCALATION_WORKLIST = [
  {
    label: 'Name',
    stateValue: 'name',
    width: '150px',
  },
  {
    label: 'NRIC',
    stateValue: 'idNumber',
  },
  {
    label: 'Gender',
    stateValue: 'gender',
  },
  {
    label: 'Date',
    stateValue: 'dateTime',
    sortBy: 'Date',
  },
  // {
  //   label: 'Package',
  //   stateValue: 'package',
  //   width: '150px',
  // },
  {
    label: 'IR result',
    stateValue: 'irResult',
    sortBy: 'ResultType',
  },
  // {
  //   label: 'Review status',
  //   stateValue: 'reviewStatus',
  //   sortBy: 'ReviewStatus',
  // },
  {
    label: 'Download status',
    stateValue: 'downloadStatus',
  },
  {
    label: 'FUT Result',
    stateValue: 'futResult',
  },
  {
    label: 'Status',
    stateValue: 'status',
  },
  {
    label: 'Note 1',
    stateValue: 'note1',
    width: '150px',
  },
  {
    label: 'Note 2',
    stateValue: 'note2',
    width: '150px',
  },
  {
    label: 'Action',
    stateValue: 'action',
  },
];
// NotDownloaded1, NotDownloaded3, NotDownloaded5, Abnormal, Abnormal1, Abnormal3, Abnormal5, Urgent, Urgent1, Urgent3, Urgent5
export const IR_RESULT_DISPLAY = {
  // NotDownloaded1: 'Not downloaded + 1',
  // NotDownloaded3: 'Not downloaded + 3',
  // NotDownloaded5: 'Not downloaded + 5',
  // Abnormal: 'Abnormal',
  // Abnormal1: 'Abnormal + 1',
  // Abnormal3: 'Abnormal + 3',
  // Abnormal5: 'Abnormal + 5',
  // Urgent: 'Urgent',
  // Urgent1: 'Urgent + 1',
  // Urgent3: 'Urgent + 3',
  // Urgent5: 'Urgent + 5',

  Urgent: 'Urgent',
  Urgent1: 'Urgent + 1',
  Urgent3: 'Urgent + 3',
};

export const REVIEW_STATUS_DISPLAY = {
  Draft: 'Draft',
  Pending: 'Pending',
  Completed: 'Completed',
};

export const WORKLIST_STATUSES_DISPLAY = {
  WaitForUpdate: 'Update status',
  Unreachable: 'Unreachable + 1',
  UnreachableAttempt2: 'Unreachable + 2',
  Contacted: 'Contacted',
};

export const DOWNLOAD_STATUS_DISPLAY = {
  Downloaded: 'Downloaded',
  NotDownload1: 'No download + 1',
  NotDownload2: 'No download + 2',
  NotDownload3: 'No download + 3',
};

export const FUT_RESULT_DISPLAY = {
  Abnormal: 'Abnormal',
  Urgent: 'Urgent',
};

export const ESCALATION_WORKLISTS_COLORS = {
  [IR_RESULT_DISPLAY.NotDownloaded1]: { txt: '#333333', background: '#F1F1F1' },
  [IR_RESULT_DISPLAY.NotDownloaded3]: { txt: '#333333', background: '#F1F1F1' },
  [IR_RESULT_DISPLAY.NotDownloaded5]: {
    txt: '#333333',
    background: '#F1F1F1',
  },
  [IR_RESULT_DISPLAY.Abnormal]: { txt: '#E37F2A', background: '#e37f2a29' },
  [IR_RESULT_DISPLAY.Abnormal1]: { txt: '#E37F2A', background: '#e37f2a29' },
  [IR_RESULT_DISPLAY.Abnormal3]: { txt: '#E37F2A', background: '#e37f2a29' },
  [IR_RESULT_DISPLAY.Abnormal5]: { txt: '#E37F2A', background: '#e37f2a29' },
  [IR_RESULT_DISPLAY.Urgent]: { txt: '#DB3D49', background: '#db3d4929' },
  [IR_RESULT_DISPLAY.Urgent1]: { txt: '#DB3D49', background: '#db3d4929' },
  [IR_RESULT_DISPLAY.Urgent3]: { txt: '#DB3D49', background: '#db3d4929' },
  [IR_RESULT_DISPLAY.Urgent5]: { txt: '#DB3D49', background: '#db3d4929' },
  [REVIEW_STATUS_DISPLAY.Draft]: { txt: '#333333', background: '#f1f1f1' },
  [REVIEW_STATUS_DISPLAY.Pending]: { txt: '#E37F2A', background: '#e37f2a29' },
  [REVIEW_STATUS_DISPLAY.Completed]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
  [WORKLIST_STATUSES_DISPLAY.WaitForUpdate]: {
    txt: '#AD5E99',
    background: '#FFE9FB',
  },
  [WORKLIST_STATUSES_DISPLAY.Unreachable]: {
    txt: '#DB3D49',
    background: '#db3d4929',
  },
  [WORKLIST_STATUSES_DISPLAY.Contacted]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },

  [DOWNLOAD_STATUS_DISPLAY.Downloaded]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
  [DOWNLOAD_STATUS_DISPLAY.NotDownload1]: {
    txt: '#333333',
    background: '#F1F1F1',
  },
  [DOWNLOAD_STATUS_DISPLAY.NotDownload2]: {
    txt: '#333333',
    background: '#F1F1F1',
  },
  [DOWNLOAD_STATUS_DISPLAY.NotDownload3]: {
    txt: '#333333',
    background: '#F1F1F1',
  },
  [FUT_RESULT_DISPLAY.Abnormal]: { txt: '#E37F2A', background: '#e37f2a29' },
  [FUT_RESULT_DISPLAY.Urgent]: { txt: '#DB3D49', background: '#db3d4929' },
};
